const state = {
  menu: {
    state: 'home',
    item: '',
  }
}

const mutations = {
  setComponent(state, { component, item }) {
    state.menu = {
      state: component,
      item: item
    }
  },
}

const actions = {
  setComponent({ commit }, data) {
    commit('setComponent', data)
  },
}

const getters = {
  menu: (state) => state.menu
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
